export type AuthErrorBannerProps = {
  message: string | null
}

export function AuthErrorBanner({ message }: AuthErrorBannerProps) {
  if (!message) {
    return null
  }

  return (
    <div
      role="alert"
      className="border-2 border-accent bg-accent-soft px-3 py-2.5 text-sm text-accent"
    >
      {message}
    </div>
  )
}
